export const getActivityFee = (activity: Activity) => {
  if (activity.fee) {
    return activity.fee;
  } else if (activity.fee === 0 && activity?.packages.length !== 0) {
    const sortedPackages = [...activity.packages].sort((a, b) => a.fee - b.fee);
    return sortedPackages[0]?.fee;
  }

  return 0;
};
